<template>
  <!-- output one line of the summary, optional with right aligned currency value -->
  <div class="summary-box-line">
    <v-row no-gutters>
      <v-col cols="12">
        <slot />
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="7">
        <slot name="left" />
      </v-col>
      <v-col cols="5"
              class="text-right">
        <slot name="right" />
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {};
</script>